'use strict';

const map = require('lodash/map');

module.exports = () => ({
    replace: true,
    restrict: 'E',
    controllerAs: '$ctrl',
    bindToController: {
        name: '@',
        types: '@'
    },

    controller: function () {
        let $ctrl = this;

        let iconSlug = `icon-${$ctrl.name}`;

        let typeClasses = $ctrl.types ? $ctrl.types.split(' ') : [];

        typeClasses = map(typeClasses, cls => {
            return `o-icon--${cls}`;
        });

        $ctrl.href = `#${iconSlug}`;

        $ctrl.classNames = [
            'o-icon',
            typeClasses.join(' '),
            iconSlug
        ].join(' ');

        return $ctrl;
    },

    template: [
        '<svg class="{{ $ctrl.classNames }}" aria-hidden="true">',
        '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="{{ $ctrl.href }}"></use>',
        '</svg>'
    ].join(''),
});



// WEBPACK FOOTER //
// ./widgets/directives/icon.js